export default {"src":"/_next/static/media/referral.5fdff79f.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};